var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EEE",
  d: "M11.671 18.156a.64.64 0 0 1 .658 0l5.831 3.52a.636.636 0 0 0 .949-.69l-1.548-6.634a.64.64 0 0 1 .203-.625l5.153-4.464a.636.636 0 0 0-.363-1.116l-6.784-.575a.64.64 0 0 1-.532-.386L12.586.928a.636.636 0 0 0-1.172 0L8.76 7.186a.64.64 0 0 1-.532.386l-6.784.575a.636.636 0 0 0-.363 1.116l5.153 4.464a.64.64 0 0 1 .203.625l-1.547 6.634a.636.636 0 0 0 .949.69z"
})));
export default SvgSvgStar;